<template>
  <div class="header">
    <div class="max-width row-block">
      <div class="left row-block" :style="!customIsLogin || isMobile ? { flex: 1 } : {}">
        <template v-if="customIsLogin && !isMobile">
          <a class="img" @click="e => resetRoute()">
            <img :src="require('../../assets/images/svg-logo.svg')" alt="" :style="{ width: '108px' }">
          </a>
          <div :style="{ width: '27.3px' }"></div>
          <div class="route-container" :class="{ active: (route.actives || []).includes($route.name), icon: !route.title }" :title="route.title.replace(/\<br\>/g, ' ')" v-for="(route, index) in routes['left']" :key="index">
            <router-link v-if="route.to" :to="route.to" class="route-block center-block">
              <div class="route-content link" :class="[route.title ? 'row-block' : 'center-block']">
                <img :src="route.icon" alt="" :style="route.iconStyle || {}">
                <template v-if="route.title">
                  <div :style="{ width: '10px' }"></div>
                  <div class="route-title" v-html="route.title"></div>
                  <div :style="{ flex: 1 }"></div>
                </template>
              </div>
            </router-link>
            <div v-else-if="route.func" class="route-block center-block function" :class="{ icon: !route.title }" @click="e => route.func()">
              <div class="route-content" :class="[route.title ? 'row-block' : 'center-block']">
                <img :src="route.icon" alt="" :style="route.iconStyle || {}">
                <template v-if="route.title">
                  <div :style="{ width: '10px' }"></div>
                  <div class="route-title" v-html="route.title"></div>
                  <div :style="{ flex: 1 }"></div>
                </template>
              </div>
            </div>
          </div>
          <div :style="{ flex: 1 }"></div>
        </template>
        <router-link v-else-if="leftHeader" class="img" :to="customIsLogin ? { name: 'main' } : { name: $route.name }">
          <img :src="require('../../assets/images/svg-logo.svg')" alt="" :style="{ width: '108px' }">
        </router-link>
      </div>
      <div class="center center-block" :style="customIsLogin ? { width: '10px'} : {}">
        <router-link v-if="(!customIsLogin || isMobile) && !leftHeader" class="img" :to="customIsLogin ? { name: 'main' } : { name: $route.name }">
          <img :src="require('../../assets/images/svg-logo.svg')" alt="" :style="{ width: '108px' }">
        </router-link>
      </div>
      <div class="right row-block" :style="{ flex: 1 }">
        <div :style="{ flex: 1 }"></div>
        <div class="user-locale-container row-block">
          <div class="user-locale-block row-block">
            <div class="user-locale-icon icon-block" :style="{ '--size': '30px' }">
              <img :src="require('../../assets/images/header-locale-icon.svg')" alt="">
            </div>
            <div class="user-locale-title">{{ languageValueMap[locale].title }}</div>
            <div class="user-locale-menu-container col-block width-full">
              <div class="user-locale-menu-block row-block" v-for="(option, oindex) in languageOptions" :key="oindex" @click="e => setLang(option.value)">
                <img :src="locale === option.value ? require('../../assets/images/radio-true.svg') : require('../../assets/images/radio-false.svg')" alt="">
                <div class="user-locale-menu-title">{{ option.title }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
          </div>
        </div>
        <div :style="{ width: '20px' }"></div>
        <div v-if="customIsLogin && !isMobile" class="row-block">
          <router-link :to="{ name: 'user' }" class="user-container row-block">
            <div v-if=false class="user-menu-container col-block width-full">
              <div class="user-menu-block col-block" v-for="(option, oindex) in menuOptions" :key="oindex">
                <template v-if="option.type === 'locale'">
                  <div v-if="locale" class="user-menu-locale-container input-group">
                    <select v-model="locale" @change="e => setLang(locale)">
                      <option v-for="(option, index) in languageOptions" :key="index" :value="option.value">{{ option.title }}</option>
                    </select>
                  </div>
                </template>
                <template v-else>
                  <component
                    class="user-menu-content row-block"
                    :is="option.to ? 'router-link' : option.link ? 'a' : 'div'"
                    :to="option.to"
                    @click="e => (option.func || (() => {}))(option)"
                  >
                    <div class="icon-block user-menu-icon" :style="{ '--size': '30px' }">
                      <img :src="option.icon" alt="">
                    </div>
                    <div class="user-menu-title" :style="{ flex: 1 }">{{ option.title }}</div>
                  </component>
                </template>
              </div>
            </div>
            <div class="user-avatar" :style="{ 'background-image': 'url(' + ((avatarUrl || require('../../assets/images/user-avatar.svg'))) + ')' }"></div>
            <div :style="{ width: '7px' }"></div>
            <div class="user-name">{{ [user.first_name, user.last_name].join(' ') }}</div>
            <div :style="{ width: '7px' }"></div>
            <div class="col-block" :style="{ height: '19px' }">
              <div :style="{ height: '7px' }"></div>
              <img :src="require('../../assets/images/solid-arrow-down.svg')" alt="">
              <div :style="{ flex: 1 }"></div>
            </div>
          </router-link>
          <div :style="{ width: '10px' }"></div>
          <div class="route-container" :class="{ active: (route.actives || []).includes($route.name), icon: !route.title }" :title="route.info.replace(/\<br\>/g, ' ')" v-for="(route, index) in routes['right']" :key="index">
            <router-link v-if="route.to" :to="route.to" class="route-block center-block">
              <div class="route-content link" :class="[route.title ? 'row-block' : 'center-block']">
                <img :src="route.icon" alt="" :style="route.iconStyle || {}">
                <template v-if="route.title">
                  <div :style="{ width: '10px' }"></div>
                  <div class="route-title">{{ route.title }}</div>
                  <div :style="{ flex: 1 }"></div>
                </template>
              </div>
            </router-link>
            <div v-else-if="route.func" class="route-block center-block function" :class="{ icon: !route.title }" @click="e => route.func()">
              <div class="route-content" :class="[route.title ? 'row-block' : 'center-block']">
                <img :src="route.icon" alt="" :style="route.iconStyle || {}">
                <template v-if="route.title">
                  <div :style="{ width: '10px' }"></div>
                  <div class="route-title">{{ route.title }}</div>
                  <div :style="{ flex: 1 }"></div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { deleteUser } from '../../api'
import nullConditionalOperator from '../../mixins/nullConditionalOperator'
import toastMethods from '../../mixins/toastMethods.vue'
import responsitive from '../../mixins/responsitive.vue'
import loginData from '../../mixins/loginData.vue'
import locale from '../../mixins/locale.vue'
import userPermission from '../../mixins/userPermission.vue'
import { downloadFile } from '../../constants/global/util'
import { _WEBSITE_VERSION } from '../../constants/global/config'

export default {
  mixins: [
    nullConditionalOperator,
    toastMethods,
    responsitive,
    loginData,
    locale,
    userPermission
  ],
  computed: {
    ...mapGetters([
      'isLogin',
      'user'
    ]),
    customIsLogin () {
      return this.isLogin && ![
        'genePanel'
      ].includes(this.$route.name)
    },
    leftHeader () {
      return this.$route.name && [
        'genePanel',
        'coverageRate'
      ].includes(this.$route.name)
    },
    routes () {
      return {
        left: [
          {
            title: this.$t('LAYOUT.header.routes.title.___caseList'),
            to: { name: 'caseList' },
            icon: require('../../assets/images/header-case-icon.svg'),
            iconStyle: { width: '16px' },
            actives: [
              'caseList'
            ]
          },
          {
            title: this.$t('LAYOUT.header.routes.title.___phenoVarDBPopulationFrequencies'),
            to: { name: 'datasetList' },
            icon: require('../../assets/images/header-dataset-icon.svg'),
            iconStyle: { width: '16px' },
            actives: [
              'datasetList',
              'datasetEdit',
              'datasetDetail'
            ]
          }
        ].filter(route => route.display !== false),
        right: [
          {
            info: this.$t('LAYOUT.header.routes.info.___userManual'),
            func: () => this.donwoladManual(),
            icon: require('../../assets/images/header-manual-icon.svg')
          },
          {
            info: this.$t('LAYOUT.header.routes.info.___logOut'),
            func: () => this.userLogout(),
            icon: require('../../assets/images/header-logout-icon.svg')
          }
        ].filter(route => route.display !== false)
      }
    },
    menuOptions () {
      return [
        {
          title: this.$t('LAYOUT.header.menu.title.___userSetting'),
          icon: require('../../assets/menuIcons/user-menu-icon.svg'),
          to: { name: 'user' }
        },
        {
          type: 'locale'
        }
      ].filter(route => route.display !== false)
    }
  },
  watch: {
    'locale' (nv) {
      this.$emit('setLang', nv)
    }
  },
  methods: {
    ...mapActions([
      'setLoginAction',
      'setRouteResetAction'
    ]),
    donwoladManual () {
      const manualData = {
        'default': {
          name: 'InheriNext-EDGE_Manual_ENG_20260825(C).pdf',
          file: 'InheriNext_manual.pdf'
        },
        'us': {
          name: 'InheriNext-EDGE_Manual_ENG_20260825(C).pdf',
          file: 'InheriNext_manual.pdf'
        },
        'jp': {
          name: 'InheriNext-EDGE_Manual_JP_20260825(C).pdf',
          file: 'InheriNext_jp_manual.pdf'
        }
      }[_WEBSITE_VERSION]
      manualData && downloadFile(manualData.name, '../../../static/' + manualData.file, '_blank')
    },
    resetRoute () {
      this.setRouteResetAction(true)
      this.$router.push({ name: 'caseList' })
    },
    async userLogout () {
      try {
        let config = this.$ls.get('userInfo')
        await deleteUser(config)
        this.setUserData(null)
        this.$router.push({ name: 'main' })
      } catch (error) {
        this.setLoginAction(true)
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/header.vue